// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hollow-dots-spinner {
  height: 15px;
  width: 90px;
}

.hollow-dots-spinner .dot {
  width: 15px;
  height: 15px;
  margin: 0 7.5px;
  border: 3px solid #4778EE;
  border-radius: 50%;
  float: left;
  transform: scale(0);
  animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;
}

.hollow-dots-spinner .dot:nth-child(1) {
  animation-delay: 0ms;
}

.hollow-dots-spinner .dot:nth-child(2) {
  animation-delay: 300ms;
}

.hollow-dots-spinner .dot:nth-child(3) {
  animation-delay: 600ms;
}

@keyframes hollow-dots-spinner-animation {
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Spinners/HollowDots/HollowDots.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,WAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,iEAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAMA;EACE;IACE,mBAAA;IACA,UAAA;EAHF;EAKA;IACE,UAAA;EAHF;AACF","sourcesContent":[".hollow-dots-spinner, .hollow-dots-spinner * {\n}\n\n.hollow-dots-spinner {\n  height: 15px;\n  width: calc(30px * 3);\n}\n\n.hollow-dots-spinner .dot {\n  width: 15px;\n  height: 15px;\n  margin: 0 calc(15px / 2);\n  border: calc(15px / 5) solid #4778EE;\n  border-radius: 50%;\n  float: left;\n  transform: scale(0);\n  animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;\n}\n\n.hollow-dots-spinner .dot:nth-child(1) {\n  animation-delay: calc(300ms * 0);\n}\n\n.hollow-dots-spinner .dot:nth-child(2) {\n  animation-delay: calc(300ms * 1);\n}\n\n.hollow-dots-spinner .dot:nth-child(3) {\n  animation-delay: calc(300ms * 2);\n\n}\n\n@keyframes hollow-dots-spinner-animation {\n  50% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
